import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';
import _upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import {
  SsoIntegration,
  SsoIntegrationDisplayStatusEnum,
} from 'graphql-common';
import getSsoDisplayStatusChipType from '@lib/utils/getSsoDisplayStatusChipType';
import Chip from '@lib/components/Chip/Chip';

type Props = {
  data: SsoIntegration;
};

export default function SsoDisplayStatusChip(props: Props) {
  const { data } = props;
  const { displayStatus } = data;
  const { t } = useTranslation();
  const options = [
    { value: SsoIntegrationDisplayStatusEnum.Active, title: t('active') },
    {
      value: SsoIntegrationDisplayStatusEnum.Deactivated,
      title: t('deactivated'),
    },
    {
      value: SsoIntegrationDisplayStatusEnum.Misconfigured,
      title: t('misconfigured'),
    },
  ];
  let label: string | undefined = '-';
  if (displayStatus) {
    label = options.find(({ value }) => value === displayStatus)?.title;
  }
  if (label === undefined)
    label = _upperFirst(_toLower(_startCase(displayStatus)));
  const type = getSsoDisplayStatusChipType(displayStatus);
  const tooltip =
    displayStatus === SsoIntegrationDisplayStatusEnum.Misconfigured
      ? t('sso-misconfigured-tooltip')
      : undefined;

  return <Chip type={type} label={label} leftIcon="circle" tooltip={tooltip} />;
}
